<template>
	<div class="section-ativo">
		<!-- Mobile -->
		<div v-if="isMobile" class="mobile-pseudo-table">
			<div class="caption">Rentabilidade dos ativos</div>
			<carousel :per-page="1" mouse-drag touch-drag :resistanceCoef="10" :minSwipeDistance="70">
				<slide v-for="(item, index) in table.items" :key="index">
					<div class="tr card-like">
						<div v-for="field in table.fields" class="v-col" :key="field.key">
							<div v-if="field.key == 'participacao'" class="th">{{field.label}} {{formatarData(dataReferencia)}}</div>
							<div v-else-if="field.key != 'nomeAtivo'" class="th">{{field.label}}</div>
							<div v-if="field.key == 'nomeAtivo'" class="td solo">
								<span class="color-ball" :style="{backgroundColor: getCorAtivo(item.codigoAtivo)}"></span>
								<p class="nowrap" :title="item[field.key]">{{item[field.key]}}</p>
							</div>
							<div v-else class="td" :class="item[field.key] < 0 ? 'negative' : 'positive'">
								{{formatFunction(item[field.key], field.formatter)}}
							</div>
						</div>
					</div>
				</slide>
			</carousel>
		</div>

		<!-- Desktop -->
		<b-table v-else :items="table.items" :fields="table.fields">
			<template #table-caption>Rentabilidade dos ativos</template>
			<template #head(participacao)="data">
				{{ data.label }} {{formatarData(dataReferencia)}}
			</template>
			<template v-slot:cell(nomeAtivo)="data">
				<div class="flex-cell">
					<span class="color-ball" :style="{backgroundColor: getCorAtivo(data.item.codigoAtivo)}"></span>
					<p class="nowrap" :title="data.value">{{data.value}}</p>
				</div>
			</template>
			<template v-slot:cell(valorAplicado)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(participacao)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidadeMes)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidade12Meses)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
			<template v-slot:cell(rentabilidadeDesdeInicio)="data">
				<span :class="data.unformatted < 0 ? 'negative' : 'positive'">{{data.value}}</span>
			</template>
		</b-table>
	</div>
</template>

<script>
import SimuladorService from "@/app/services/Simulador/simulador.service";
import SpinnerService from '../../services/spinner.service';
import UtilsService from '../../services/utils.service';
import moment from 'moment';
import { SweetModal } from "sweet-modal-vue";
import { Carousel, Slide } from 'vue-carousel';
import ModalAcoesAtivo from '@/app/components/Modals/ModalAcoesAtivo';

export default {
	components: {
		SweetModal,
		Carousel,
		Slide,
		ModalAcoesAtivo
	},
	props: {
		periodoSelecionado: {
			default: 0,
			type: Number
		},
		forcarRenderizacao: {
			default: 0,
			type: Number
		}
	},
	data() {
		return {
			table: {
				fields: [
					{ key: 'nomeAtivo', label: 'Nome' },
					{ key: 'valorAplicado', label: 'Valor Aplicado', formatter: 'formatarDinheiro', class: 'text-center' },
					{ key: 'participacao', label: 'Participação em:', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidadeMes', label: 'Rentabilidade no mês', formatter: 'formatarPorcentagem', class: 'text-center' },
					// { key: 'rentabilidadeAno', label: 'Rentabilidade no  ano', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidade12Meses', label: 'Rentabilidade em 12 meses', formatter: 'formatarPorcentagem', class: 'text-center' },
					// { key: 'rentabilidade24Meses', label: 'Rentabilidade em 24 meses', formatter: 'formatarPorcentagem', class: 'text-center' },
					{ key: 'rentabilidadeDesdeInicio', label: 'Rentabilidade desde o início', formatter: 'formatarPorcentagem', class: 'text-center' },
				],
				items: []
			},
			ativos: []
		};
	},
	methods: {
		carregarDados() {
			SimuladorService.obterRentabilidadesTabelaAtivos({
				token: this.$route.query.token,
				dataReferencia: this.dataReferencia
			}).then((retorno) => {
				if (retorno.sucesso) {
					this.table.items = retorno.rentabilidades;
				}
			});
		},
		formatarData(data) {
			return moment(data).format("DD/MM/YYYY");
		},
		formatarDinheiro(numero) {
			return "R$ " + UtilsService.formatNumber(numero);
		},
		formatarPorcentagem(numero) {
			return UtilsService.formatNumber(numero) + "%";
		},
		nomeAtivoMinimizado(nome) {
			if (nome && nome.length > 12) {
				return nome.substring(0, 12);
			} else {
				return nome;
			}
		},
		openModalMobile(index) {
			this.ativoSelecionado = this.ativos[0];
			this.$refs.modalMobile.open();
		},
		iconeStonksParaValor(valor) {
			return valor > 0
				? require("../../assets/img/green_arrow.png") // Stonks
				: require("../../assets/img/red_arrow.png");  // Not Stonks
		},
		abrirModalAtivo(item) {
			this.ativoSelecionado = item;
			this.$refs.modalAcoesAtivo.abrir();
		},
		tratarAcaoModal(acao) {
			this.$emit('acaoRealizada', acao);
		},
		getCorAtivo(id) {
			let ativo = this.coresAtivos.find(el => el.codigo == id);
			return ativo ? ativo.cor : '#8C8C8C';
		},
		formatFunction(value, formatter) {
			let func = this[formatter];
			if (typeof(func) == 'function') {
				return func(value)
			}
			return value;
		}
	},
	computed: {
		dataReferencia() {
			let datas = this.$store.getters.getDatasPeriodo;
			return moment(datas.maiorData ?? new Date()).format("YYYY-MM-DD");
		},
		coresAtivos() {
			return this.$store.getters.getCoresAtivos;
		},
		isMobile() {
            return this.$mq != 'desktop';
        }
	},
	watch: {
		forcarRenderizacao: {
			handler(n, o) {
				this.carregarDados();
			},
			deep: true
		}
	},
	beforeMount() {
		this.carregarDados();
	},
};
</script>

<style lang="scss">
	.section-ativo .mobile-pseudo-table {
		width: 100vw;
    	margin-left: -16px;

		.caption {
			margin-left: 16px;
		}

		.tr {
			margin: 0 16px;
		}
	}
</style>